import React from 'react';
// import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Button from '@firsttable/web-components/atoms/Button';
import { isFirstCharacterAVowel } from '@firsttable/functions';
import { useQuery } from '@apollo/client';
import NavButtonComponent from '../../atoms/NavButton';

const GET_USER_CITY = gql`
  query getUserCity{
    user: Member(siteId: ${parseInt(process.env.GATSBY_SITE_ID, 10)}) {
      city {
        slug
        menuTitle
      }
    }
  }
`;

const BookRestaurant = () => {
  const { loading, error, data } = useQuery(GET_USER_CITY, {
    ssr: false,
    fetchPolicy: 'network-only',
    errorPolicy: 'none',
  });
  if (error) {
    return null;
  }
  if (loading || !data) {
    return <Button isLoading={loading} type="button" kind="cta" />;
  }
  const {
    user: { city },
  } = data;
  if (!city) {
    return null;
  }
  return (
    <Button
      NavComponent={NavButtonComponent}
      to={city.slug}
      isLoading={loading}
      type="button"
      kind="cta"
    >
      Book {isFirstCharacterAVowel(city.menuTitle) ? 'an' : 'a'}{' '}
      {city.menuTitle} restaurant
    </Button>
  );
};

BookRestaurant.propTypes = {};
BookRestaurant.defaultProps = {};

export default BookRestaurant;
